/* ---------- src/pages/StudentSpace.js ---------- */
import React from "react";
import { useTranslation } from "react-i18next";
import "../App.css";

const StudentSpace = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  return (
    <main
      className={`container ${isRTL ? "arabic-font" : ""}`}
      style={{ direction: isRTL ? "rtl" : "ltr", padding: "2rem 1rem" }}
    >
      {/* ---------- Title ---------- */}
      <h1 style={{ color: "#F4888C", marginBottom: "1rem" }}>
        💌 {t("studentSpaceTitle")}
      </h1>

      {/* ---------- Intro ---------- */}
      <p style={{ maxWidth: 800, lineHeight: 1.7 }}>
        {t("studentSpaceIntro")}
      </p>

      {/* ---------- Submission Instructions ---------- */}
      <section style={{ marginTop: "2.5rem" }}>
        <h2>{t("studentSpaceSubmitHeading")}</h2>
        <p>
          {t("studentSpaceSubmitDesc")}{" "}
          <strong>letters@mydearteachermovement.com</strong>
        </p>
        <ul>
          <li>{t("studentSpaceAttachLetter")}</li>
          <li>{t("studentSpaceAttachDrawing")}</li>
          <li>{t("studentSpaceAttachVoice")}</li>
        </ul>
        <p style={{ marginTop: "1rem" }}>
          ✨ {t("studentSpaceAnonymous")}
        </p>
      </section>

      {/* ---------- Download Template ---------- */}
      <section style={{ marginTop: "2.5rem" }}>
        <h2>{t("studentSpaceTemplateHeading")}</h2>
        <p>{t("studentSpaceTemplateDesc")}</p>
        <a
          className="btn"
          href="/downloads/dear-teacher-letter-template.pdf"
          target="_blank"
          rel="noreferrer"
        >
          {t("studentSpaceTemplateBtn")}
        </a>
      </section>

      {/* ---------- Gallery Placeholder ---------- */}
      <section style={{ marginTop: "3rem" }}>
        <h2>🖼️ {t("studentSpaceGalleryHeading")}</h2>
        <p>{t("studentSpaceGalleryDesc")}</p>
      </section>

      {/* ---------- Consent Note ---------- */}
      <section
        style={{
          marginTop: "3rem",
          borderTop: "1px solid #f4c7c9",
          paddingTop: "1.5rem",
        }}
      >
        <h3>✅ {t("studentSpaceConsentHeading")}</h3>
        <p>{t("studentSpaceConsentText")}</p>
      </section>

      {/* ---------- Founder Quote ---------- */}
      <blockquote
        style={{
          marginTop: "2.5rem",
          fontStyle: "italic",
          color: "#555",
        }}
      >
        “{t("studentSpaceFounderQuote")}”
        <br />— Amb. Beauty Tommy, Founder
      </blockquote>

      {/* ---------- Mail Club (future) ---------- */}
      <section style={{ marginTop: "3rem" }}>
        <h2>📬 {t("studentSpaceMailClubHeading")}</h2>
        <p>{t("studentSpaceMailClubDesc")}</p>
        <p style={{ marginTop: "0.5rem" }}>
          {t("studentSpaceMailClubInteractive")}
        </p>
        <button className="btn grey-btn" disabled>
          {t("studentSpaceMailClubBtn")}
        </button>
      </section>
    </main>
  );
};

export default StudentSpace;
